import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Login", -1)

import { data } from '../composables/useData';
import { method } from '../composables/useMethod';
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter();



return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            "offset-sm": "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(method).login(_unref(router))), ["prevent"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(data).loginUser.email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).loginUser.email) = $event)),
                            label: "email",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(data).loginUser.password,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).loginUser.password) = $event)),
                            label: "Password",
                            type: "password",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            type: "submit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Login ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})